(() => {
  'use strict';
  const data = window.FIRMWARE_ROUTES;
  // Gravity Forms 2.9.20: maybe_trim_input + matches_conditional_operation.
  // Current predicates use English model names and nonnumeric firmware strings.
  const phpTrim = value => String(value ?? '').replace(/^[ \t\n\r\0\v]+|[ \t\n\r\0\v]+$/g, '');
  const fold = value => phpTrim(value).replace(/[A-Z]/g, c => c.toLowerCase());
  function compare(actual, expected, operator) {
    const a = fold(actual), b = fold(expected);
    if (operator === 'is') return a === b;
    if (operator === 'starts_with') return b !== '' && a.startsWith(b);
    if (operator === 'contains') return b !== '' && a.includes(b);
    return false;
  }
  function matchesLogic(route, fields) {
    const rules = route.logic?.rules || [];
    if (!rules.length) return true;
    if (rules.some(rule => !['3','4'].includes(String(rule.fieldId)) || !['is','starts_with','contains'].includes(rule.operator))) return false;
    const results = rules.map(rule => compare(fields[String(rule.fieldId)], rule.value, rule.operator));
    return route.logic.logicType === 'all' ? results.every(Boolean) : route.logic.logicType === 'any' ? results.some(Boolean) : false;
  }
  function match(modelLabel, currentVersion) {
    const model = data.modelChoices.find(label => fold(label) === fold(modelLabel));
    if (!model) return {status:'invalid_model',reason:'invalid_model',pageId:null,matches:[]};
    const required = data.versionRequiredModels.includes(model);
    const version = required ? phpTrim(currentVersion) : '';
    if (required && !version) return {status:'version_required',reason:'version_required',model,version,pageId:null,matches:[]};
    const fields = {'4':model,'3':version};
    const hits = data.routes.filter(route => {
      if (!route.active || route.isDefault) return false;
      // Two original version-only rules lack a model guard. They may only be
      // reviewed within their documented model family; never cross-match.
      if (!route.modelGuards.length && route.expectedModel && fold(route.expectedModel) !== fold(model)) return false;
      return matchesLogic(route,fields);
    });
    if (!hits.length) return {status:'not_found',reason:'unknown_version',model,version,pageId:null,matches:[]};
    const route = hits[0]; // Preserve exported source precedence.
    const base = {model,version,route,pageId:route.pageId,matches:hits.map(r=>({order:r.order,id:r.id,pageId:r.pageId}))};
    const targets = new Set(hits.map(r => r.pageId || r.destination.pageUrl));
    if (targets.size > 1) return {...base,status:'manual_review',reason:'conflicting_targets'};
    if (!route.modelGuards.length) return {...base,status:'manual_review',reason:'missing_model_guard'};
    if (route.issues.some(issue=>issue.includes('hardware_prefix_transition'))) return {...base,status:'manual_review',reason:'prefix_transition'};
    if (route.issues.includes('shared_model_mapping_requires_review')) return {...base,status:'manual_review',reason:'shared_model_mapping'};
    if (!route.destination.pageUrl || route.destination.status === 'unresolved_public_page') return {...base,status:'manual_review',reason:'missing_target'};
    return {...base,status:'matched',reason:null};
  }
  window.FirmwareMatcher = Object.freeze({match,phpTrim});
})();
